// Monta a arvore de pastas/arquivos do explorador da tela "Detalhe da Skill"
// (Tarefa 6.2, specs/skills/plan.md) a partir da lista plana de paths
// devolvida por GET /get_skill (`files: [{path}, ...]`, manifesto da skill).
//
// SKILL.md sempre vem primeiro (selecionado por padrao ao abrir, Tarefa 6.1),
// depois pastas (ordem alfabetica), depois os demais arquivos da raiz (ordem
// alfabetica) - mesma ordem visual do node do Figma ("Card Skills"/explorador
// de arquivos, arquivo "Skills", node 101:600).
export function buildFileTree(files) {
    const root = { type: 'folder', name: '', path: '', children: [] };

    for (const { path } of files) {
        const parts = path.split('/');
        let node = root;
        parts.forEach((part, index) => {
            const isFile = index === parts.length - 1;
            const partPath = parts.slice(0, index + 1).join('/');
            if (isFile) {
                node.children.push({ type: 'file', name: part, path: partPath });
                return;
            }
            let folder = node.children.find((child) => child.type === 'folder' && child.name === part);
            if (!folder) {
                folder = { type: 'folder', name: part, path: partPath, children: [] };
                node.children.push(folder);
            }
            node = folder;
        });
    }

    return sortNodes(root.children, true);
}

// Comparacao case-insensitive (nao so' o literal "SKILL.md") - o manifesto
// de uma skill importada via .zip preserva a grafia original do arquivo
// (backend/skills/helpers.py::_find_skill_md e' case-insensitive mas nao
// renomeia o path armazenado), entao esse arquivo pode chegar aqui como
// "Skill.md"/"skill.md" etc. e ainda deve vir primeiro.
function isSkillMdNode(node) {
    return node.type === 'file' && node.name.toLowerCase() === 'skill.md';
}

function sortNodes(nodes, isRoot) {
    const sorted = [...nodes].sort((a, b) => {
        if (isRoot && isSkillMdNode(a)) return -1;
        if (isRoot && isSkillMdNode(b)) return 1;
        if (a.type !== b.type) return a.type === 'folder' ? -1 : 1;
        return a.name.localeCompare(b.name);
    });
    return sorted.map((node) => (
        node.type === 'folder' ? { ...node, children: sortNodes(node.children, false) } : node
    ));
}
